import styled, { css } from 'styled-components';

import RadioItem from '../RadioItem';

export const StyledRadioList = styled.div<{
  shaded?: boolean;
  noBox?: boolean;
  horizontal?: boolean;
  isValid?: boolean;
  hasWarning?: boolean;
  hasCaution?: boolean;
  hasInfo?: boolean;
  isTouched?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
}>`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 3px;
  border-style: solid;
  padding: ${({ theme }) => theme?.RadioList?.padding};

  ${({ shaded }) => shaded && css`
    border-width: ${({ theme }) => theme?.RadioList?.shadedBoxBorderWidth};
    border-color: ${({ theme }) => theme?.RadioList?.shadedBoxBorderColor};
    border-bottom-color: ${({ theme }) => theme?.RadioList?.shadedBoxBorderBottomColor};
  `}

  ${({ shaded }) => !shaded && css`
    border-color: ${({ theme }) => theme?.RadioList?.boxBorderColor};
    border-bottom-color: ${({ theme }) => theme?.RadioList?.boxBorderBottomColor};
    border-width: 1px;
  `}

  ${({ noBox }) => noBox && css`
    background: transparent;
    padding: 0;
    border: 0;
  `}

  ${RadioItem.StyledLabel} {
    padding: ${({ theme }) => theme?.RadioList?.itemPadding};
    margin-bottom: ${({ theme }) => theme?.RadioList?.itemMarginBottom};

    ${({ noBox }) => noBox && css`
      padding: ${({ theme }) => theme?.RadioList?.noBoxItemPadding};
    `}

    ${({ horizontal, noBox }) => horizontal && !noBox && css`
      padding: ${({ theme }) => theme?.RadioList?.horizontalItemPadding};
    `}
  }

  ${({
    noBox, horizontal, isValid, hasWarning, hasCaution, hasInfo, isTouched, theme, disabled, readOnly,
  }) => !disabled && !readOnly && !noBox && css`
    ${!horizontal && css`
      ${RadioItem.StyledLabel}:hover {
        background: ${theme?.RadioList?.boxItemHoverBackground};
      }
    `}

    ${isValid === false && isTouched === true && css`
      border-color: ${theme?.RadioList?.invalidBoxBorderColor};
      border-width: ${theme?.RadioList?.invalidBoxBorderWidth};
    `}

    ${isValid !== false && hasInfo === true && isTouched === true && css`
      border-color: ${theme?.RadioList?.infoBoxBorderColor};
      border-width: ${theme?.RadioList?.invalidBoxBorderWidth};
    `}

    ${isValid !== false && hasCaution === true && isTouched === true && css`
      border-color: ${theme?.RadioList?.cautionBoxBorderColor};
      border-width: ${theme?.RadioList?.invalidBoxBorderWidth};
    `}
  
    ${isValid !== false && hasWarning === true && isTouched === true && css`
      border-color: ${theme?.RadioList?.warningBoxBorderColor};
      border-width: ${theme?.RadioList?.invalidBoxBorderWidth};
    `}
  `}
`;

export const StyledRadioListItemWrapper = styled.div<{
  noBox?: boolean;
  horizontal?: boolean;
  isValid?: boolean;
  hasWarning?: boolean;
  hasCaution?: boolean;
  hasInfo?: boolean;
  isTouched?: boolean;
}>`
  ${({ horizontal }) => horizontal && css`
    display: flex;
    flex-wrap: wrap;
  `}

  ${({ horizontal, noBox }) => noBox && horizontal && css`
    margin-bottom: -16px;
  `}

  ${({ horizontal, noBox, theme }) => noBox && !horizontal && css`
    margin-bottom: ${theme?.RadioList?.noBoxLastItemMarginBottom};
  `}

  ${({ noBox, isValid, hasWarning, hasCaution, hasInfo, isTouched, theme, horizontal }) => !noBox && (isValid === false || hasWarning === true || hasCaution === true || hasInfo === true) && isTouched === true && horizontal && css`
    margin: ${theme?.RadioList?.invalidBoxOffset};
  `}

  ${({ noBox, isValid, hasWarning, hasCaution, hasInfo, isTouched, theme, horizontal }) => (
    !noBox && (isValid === false || hasWarning === true || hasCaution === true || hasInfo === true) && isTouched === true && !horizontal
  ) && css`
    ${RadioItem.StyledLabel} {
      padding: ${theme?.RadioList?.invalidBoxOffsetPadding};

      &:first-child {
        padding-top: ${theme?.RadioList?.invalidBoxOffsetVerticalPadding};
      }

      &:last-child {
        padding-bottom: ${theme?.RadioList?.invalidBoxOffsetVerticalPadding};
      }
    }  
  `}
`;
